var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"case"}},[_c('Title',{attrs:{"title":_vm.title}}),_c('SelectedCase',{attrs:{"caseList":_vm.list}}),_c('div',{staticClass:"line"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }